const C = {
  name: "Gaming",
  dimensions: { width: 33, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4788)">
    <path d="M25.9951 27.0029C25.4451 27.0029 24.9951 27.4529 24.9951 28.0029C24.9951 28.5529 25.4451 29.0029 25.9951 29.0029C26.5451 29.0029 26.9951 28.5529 26.9951 28.0029C26.9951 27.4529 26.5451 27.0029 25.9951 27.0029Z" />
    <path d="M21.9951 31.0029C21.4451 31.0029 20.9951 31.4529 20.9951 32.0029C20.9951 32.5529 21.4451 33.0029 21.9951 33.0029C22.5451 33.0029 22.9951 32.5529 22.9951 32.0029C22.9951 31.4529 22.5451 31.0029 21.9951 31.0029Z" />
    <path d="M30.9951 34.0029C30.9951 36.2129 29.2051 38.0029 26.9951 38.0029H3.99512C3.44512 38.0029 2.99512 37.5529 2.99512 37.0029V2.00293H5.99512V21.0029C5.99512 21.5529 6.44512 22.0029 6.99512 22.0029H26.9951C27.5451 22.0029 27.9951 21.5529 27.9951 21.0029V2.00293H29.9951C30.5451 2.00293 30.9951 2.45293 30.9951 3.00293V34.0029ZM25.9951 2.00293V20.0029H7.99512V2.00293H25.9951ZM30.9951 0.00292969H27.9951H5.99512H2.99512C1.89512 0.00292969 0.995117 0.90293 0.995117 2.00293V38.0029C0.995117 39.1029 1.89512 40.0029 2.99512 40.0029H26.9951C30.3051 40.0029 32.9951 37.3129 32.9951 34.0029V2.00293C32.9951 0.90293 32.0951 0.00292969 30.9951 0.00292969Z" />
    <path d="M11.9951 29.0029H10.9951V28.0029C10.9951 27.4529 10.5451 27.0029 9.99512 27.0029C9.44512 27.0029 8.99512 27.4529 8.99512 28.0029V29.0029H7.99512C7.44512 29.0029 6.99512 29.4529 6.99512 30.0029C6.99512 30.5529 7.44512 31.0029 7.99512 31.0029H8.99512V32.0029C8.99512 32.5529 9.44512 33.0029 9.99512 33.0029C10.5451 33.0029 10.9951 32.5529 10.9951 32.0029V31.0029H11.9951C12.5451 31.0029 12.9951 30.5529 12.9951 30.0029C12.9951 29.4529 12.5451 29.0029 11.9951 29.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4788">
    <rect width="32" height="40" fill="currentColor" transform="translate(0.995117 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>  

  `
};
export {
  C as Gaming
};
